import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import React from 'react';

import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

import QuoteModel from 'commons-vehicle/Quote/models/QuoteModel.js';

import AddToGarageButton from 'commons-vehicle/Quote/components/AddToGarage/AddToGarageButton.jsx';
import AppointmentCTA from 'commons-vehicle/Vehicle/components/CallToAction/Appointment/AppointmentCTA.jsx';
import BuyOnlineCTA from 'commons-vehicle/Vehicle/components/CallToAction/BuyOnline/BuyOnlineCTA.jsx';
import TradeInCTA from 'commons-vehicle/Vehicle/components/CallToAction/TradeIn/TradeInCTA.jsx';

import 'commons-vehicle/Vehicle/components/CallToAction/VehicleCtaBar/VehicleCtaBar.scss';

const VehicleCtaBar = ({ quote, actions }) => {
    const trackBuyOnlineCta = () => AnalyticsService.gaTrigger(TAGS.RESERVE_IT_NOW_CTA_NEW(quote.vehicle.model));

    const trackBuyOnlineCtaOnEndProcessGaTag = TAGS.RESERVE_IT_NOW_PROCESS_ENDED_NEW(this.props.quote.vehicle.model);

    const trackAppointmentCta = () => AnalyticsService.gaTrigger(TAGS.PREPARE_YOUR_VISIT_CTA_NEW(quote.vehicle.model));

    const appointmentCtaOnEndProcessGaTag = TAGS.PREPARE_YOUR_VISIT_PROCESS_ENDED_NEW(this.props.selectedModel.model);
    return (
        <div className="build-and-quote-sticky-cta-link">
            <MediaQuery maxWidth={768}>
                <AddToGarageButton quote={quote} onClick={actions.setQuoteLead} />
            </MediaQuery>
            <TradeInCTA quote={quote} />
            <AppointmentCTA
                quote={quote}
                iconClass="icon-calendar"
                onClick={trackAppointmentCta}
                onEndProcessGaTag={appointmentCtaOnEndProcessGaTag}
            />
            <BuyOnlineCTA
                quote={quote}
                iconClass="icon-shopping-cart"
                onClick={trackBuyOnlineCta}
                onEndProcessGaTag={trackBuyOnlineCtaOnEndProcessGaTag}
            />
        </div>
    );
};

VehicleCtaBar.propTypes = {
    actions: PropTypes.shape({
        setQuoteLead: PropTypes.func.isRequired,
    }).isRequired,
    quote: PropTypes.instanceOf(QuoteModel).isRequired,
};

VehicleCtaBar.displayName = 'VehicleCtaBar';

export default VehicleCtaBar;



// WEBPACK FOOTER //
// ./src/Vehicle/components/CallToAction/VehicleCtaBar/VehicleCtaBar.jsx